import React from "react";

import { Button, Icon, Stack } from "@shopify/polaris";

import styles from "./styles.module.scss";

const Index = ({ children, icon, fontWeight = 400, ...rest }) => {
  return (
    <div className={styles["ButtonLarge"]}>
      <Button primary size="large" {...rest}>
        <Stack alignment="trailing" distribution="center" spacing="tight">
          {icon && (
            <span className={styles["content"]}>
              <Icon source={icon} />
            </span>
          )}
          <Stack.Item>
            <span className={styles["content"]} style={{ fontWeight }}>
              {children}
            </span>
          </Stack.Item>
        </Stack>
      </Button>
    </div>
  );
};

export default Index;
